/**
 * O selo de "retirada no estande" é por parceiro, não por item: o modo de
 * entrega mora em `partner_store_settings.delivery_mode`, e todo item de um
 * parceiro em modo `estande` é retirado lá. A API já resolve isso e manda
 * `delivery_mode` em cada item — aqui só se lê.
 *
 * @param {{ delivery_mode?: string | null }} item
 * @returns {boolean}
 */
export function isBoothPickup(item) {
  return item?.delivery_mode === 'estande'
}

export const BOOTH_PICKUP_LABEL = 'Retirada no estande'
